export const SITE = {
  name: "Proscenio Wedding",
  tagline: "Music Planner per Matrimoni ed Eventi",
  phone1: "0532.869106",
  phone2: "334.8084704",
  email: "musica-matrimoni@proscenio.solutions",
  address: "Piazza Giuseppe Mazzini, 13 — Ro Riva del Po, Ferrara (44030)",
  parent: "Proscenio Solutions di Stefano Ongaro",
};

export const NAV_LINKS = [
  { id: "chi-siamo", label: "Chi Siamo" },
  { id: "servizi", label: "Servizi" },
  { id: "formazioni", label: "Formazioni" },
  { id: "generi", label: "Generi" },
  { id: "gallery", label: "Gallery" },
  { id: "recensioni", label: "Recensioni" },
  { id: "faq", label: "FAQ" },
  { id: "contatti", label: "Contatti" },
];

export const SERVICES = [
  {
    code: "01",
    name: "Pack Base — Cerimonia",
    price: "Da 300€",
    desc: "L'essenziale: musica live per la tua cerimonia in chiesa o in comune. Repertorio classico, sacro o moderno, costruito su misura sui tuoi gusti.",
    features: ["Cerimonia religiosa o civile", "Solista o duo strumentale", "Repertorio personalizzato", "Coordinamento con il celebrante"],
  },
  {
    code: "02",
    name: "Pack Tradizionale",
    price: "Da 800€",
    desc: "Cerimonia + pranzo o cena: un accompagnamento musicale fluido per non spezzare l'emozione, dall'altare alla tavola.",
    features: ["Pack Base incluso", "Intrattenimento pranzo o cena", "Trio o quartetto live", "Setlist concordata"],
    highlight: true,
  },
  {
    code: "03",
    name: "Pack Completo",
    price: "Fino a 2.000€",
    desc: "Cerimonia, aperitivo e ricevimento: un'esperienza musicale a 360 gradi. Dall'ingresso al taglio della torta, ogni momento è una scena.",
    features: ["Pack Tradizionale incluso", "Aperitivo musicale", "Ensemble fino a orchestra", "Brani d'autore su richiesta"],
  },
];

export const FORMAZIONI = [
  { name: "Solista", icon: "Music2", desc: "Pianoforte, organo, chitarra o voce: l'essenza nuda di una melodia." },
  { name: "Duo", icon: "Users", desc: "Violino + pianoforte, clarinetto + organo, voce + chitarra. Eleganza in dialogo." },
  { name: "Trio", icon: "Music", desc: "Tre voci strumentali per un suono pieno e intimo allo stesso tempo." },
  { name: "Quartetto", icon: "Music3", desc: "Quartetto d'archi o ensemble misto. La forma classica della cerimonia." },
  { name: "Ensemble", icon: "Mic2", desc: "Cinque o più musicisti per dare profondità e teatralità all'evento." },
  { name: "Orchestra", icon: "Drum", desc: "Orchestra a parti reali: il massimo della solennità e dell'impatto." },
];

export const GENERI = [
  { name: "Classica", tall: true, hint: "Bach, Pachelbel, Vivaldi" },
  { name: "Sacra & Corale", hint: "Ave Maria, Panis Angelicus" },
  { name: "Jazz & Swing", hint: "Standard americani anni '40-'60" },
  { name: "Italiana", hint: "Cantautori e classici" },
  { name: "Latina", hint: "Bossa, samba, tango" },
  { name: "Revival", hint: "Anni '70, '80, '90" },
  { name: "Colonne Sonore", tall: true, hint: "Morricone, Williams, Einaudi" },
  { name: "Pop & Rock", hint: "Arrangiamenti acustici e ensemble" },
];

export const GALLERY = [
  { src: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1400&q=80", alt: "Cerimonia in chiesa", caption: "Cerimonia religiosa" },
  { src: "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?auto=format&fit=crop&w=1400&q=80", alt: "Quartetto d'archi", caption: "Quartetto d'archi" },
  { src: "https://images.unsplash.com/photo-1511795409834-ef04bbd61622?auto=format&fit=crop&w=1400&q=80", alt: "Ricevimento elegante", caption: "Ricevimento" },
  { src: "https://images.unsplash.com/photo-1606216794074-735e91aa2c92?auto=format&fit=crop&w=1400&q=80", alt: "Violino solo", caption: "Violino solista" },
  { src: "https://images.unsplash.com/photo-1583939003579-730e3918a45a?auto=format&fit=crop&w=1400&q=80", alt: "Pianista al matrimonio", caption: "Pianoforte da concerto" },
  { src: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1400&q=80", alt: "Sposi all'altare", caption: "L'attimo del Sì" },
  { src: "https://images.unsplash.com/photo-1464366400600-7168b8af9bc3?auto=format&fit=crop&w=1400&q=80", alt: "Banchetto nuziale", caption: "Banchetto nuziale" },
  { src: "https://images.unsplash.com/photo-1525772764200-be829a350797?auto=format&fit=crop&w=1400&q=80", alt: "Cerimonia all'aperto", caption: "Cerimonia all'aperto" },
];

export const FAQ = [
  { q: "Quali zone coprite?", a: "Operiamo principalmente in Emilia-Romagna (Ferrara, Bologna, Modena, Ravenna) ma siamo disponibili per trasferte sull'intero territorio nazionale. Eventuali sovrapprezzi sono concordati in base alla distanza." },
  { q: "Posso scegliere brani non in repertorio?", a: "Assolutamente sì. Il programma viene concordato insieme: siamo disposti a imparare nuovi brani su richiesta degli sposi, purché concordati con il giusto anticipo." },
  { q: "Con quanto anticipo bisogna contattarvi?", a: "Almeno due mesi prima dell'evento, idealmente di più nei mesi di alta stagione (maggio–settembre). Per matrimoni in periodi particolari consigliamo di prenotare con largo anticipo." },
  { q: "Avete strumentazione propria?", a: "Sì, disponiamo di tutta la strumentazione necessaria: strumenti acustici, sistema di amplificazione, microfoni e supporti. Nessuna richiesta tecnica particolare al cliente." },
  { q: "Come funziona il pagamento?", a: "Il pagamento è da concordare in fase di preventivo, comunque entro 48 ore prima dell'evento. Eventuali ore extra vengono concordate in anticipo." },
  { q: "Suonate anche all'aperto?", a: "Sì, eseguiamo regolarmente cerimonie ed eventi all'aperto. Valutiamo insieme la location per garantire qualità acustica e protezione strumenti." },
];

export const STATS = [
  { value: "+10", label: "Anni di esperienza" },
  { value: "5.0", label: "Rating medio" },
  { value: "100%", label: "Coppie soddisfatte" },
  { value: "300+", label: "Cerimonie realizzate" },
];
